import React, { useState, useContext } from 'react';
import { FooterContainer, FooterElement, About, ModalContainer, GridDiv, ColumnDiv } from './Footer.styles';
import classnames from 'classnames'
import { ScrollContext } from '../../context/ScrollContext';

const Footer = () => {
    const [ modal, toggleModal ] = useState(false)
    const { vHeight, scrollPos, documentHeight } = useContext(ScrollContext)

    documentHeight 
        ? ((documentHeight - scrollPos) > (vHeight * 2) && modal) && toggleModal(false) 
        : console.log('Loading total height')

    return ( 
        <FooterContainer
            onClick={() => modal && toggleModal(false)}
        >
            <ModalContainer
                className={classnames({'show': modal})}
            >
            <GridDiv>
                <ColumnDiv>
                    <h1>
                        Hi there! 
                    </h1>
                    <p>
                        Let me start with a quick introduction,
                        my name is András Szesztai, currently residing in beautiful Netherlands - more specifically in cheeseful Gouda 
                        <span
                            role="img"
                            aria-label="cheese"
                        >
                            {' '}🧀{' '} 
                        </span>
                        -, but originally from lovely Hungary.
                    </p>
                    <p>
                        To sum up my career and education, I finished my master's in international relations, 
                        learned French and Russian on the way, and experienced the hospitality of Scotland and France for some time.
                    </p>
                    <p>
                        The meantime I fell in love with data visualisation by using Tableau and with the help of many many amazing people who I saw passionate about communicating complex data in some
                        of the most beautiful, elegant and creative ways.
                    </p>
                </ColumnDiv>
                <ColumnDiv>
                    <p>
                        At the amazing company I currently work at, Newzoo, I got the chance to learn how to create engaging visualisations by combining the power of d3.js and React.
                        So as of now, I do just that, both at work and in most of my spare time.
                    </p>
                    <p>
                        My mission is to somehow use my skillset for making our world a better place by helping organisations to communicate their data better to their audience. 
                        And here exactly where you might come into the picture.
                    </p>
                    <p>
                        If you are someone from a non-profit organization with data that you have been considering to make available for the broader public to 
                        inform people about and engage them with your cause, then do not hesitate to get in touch and let me be your
                        data visualisation volunteer for a project or two!
                    </p>
                </ColumnDiv>
            </GridDiv>
            </ModalContainer>
            <About
                onClick={() => toggleModal(true)}
            >
                About
            </About>
            <FooterElement>
                The design and layout of this page was inspired by &nbsp;   <a  href="https://dean.casa/" 
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >Dana Casalena's </a> &nbsp; amazing website.
            </FooterElement>
        </FooterContainer>
     );
}
 
export default Footer;